export interface ErrorItem {
  message: string[];
  subheading: string;
}

export function copyErrorToClipboard(
  error: ErrorItem,
  onSuccess?: () => void,
  onError?: (err: unknown) => void
): void {
  if (!error) {
    console.warn('No error provided to copy.');
    return;
  }

  const copyText = `${JSON.stringify(error.message)}: '${error.subheading}'`;

  navigator.clipboard
    .writeText(copyText)
    .then(() => {
      onSuccess?.();
    })
    .catch((err) => {
      onError?.(err);
    });
}
